export default "__VITE_ASSET__Cf59bmgQ__"